import { useEntityStore } from '@ContractBuilder/store';
import { useCommentsUIStore } from '@ContractBuilder/store/comments.store';
import { isEndorsementData } from '@ContractBuilder/types';
import { isReviewStatus } from '@helpers/status';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { isEndorsementViewPath, isTemplatePath } from '@utils/app-paths';

import { InlineCommentPill } from '../components/InlineCommentPill';
import { useInlineCommentSelection } from '../hooks/useInlineCommentSelection';

export const InlineCommentPillController = () => {
  const getFeatureFlagState = useFeatureFlags();
  const submission = useEntityStore(({ submission }) => submission);
  const startThread = useCommentsUIStore(({ startThread }) => startThread);

  const enabled =
    getFeatureFlagState('Comments') &&
    Boolean(submission) &&
    !isEndorsementData(submission) &&
    isReviewStatus(submission?.status) &&
    !isTemplatePath() &&
    !isEndorsementViewPath();

  const { selection, dismiss } = useInlineCommentSelection(enabled);

  if (!selection) {
    return null;
  }

  return (
    <InlineCommentPill
      onClick={() => {
        startThread(selection.blockId, selection.anchor);
        dismiss();
      }}
      rect={selection.rect}
    />
  );
};
